<div class="p-no-permission-container">
  <img src="../../../../../assets/images/img-404.svg" alt="">
  <p>{{ 'Sorry. You don\'t have enough permissions' | translate }}</p>
  <button pButton type="button" label="Login" class="p-button-secondary p-content-button p-mr-1"
    (click)="login()"></button>
</div>
